import {
    Box, Flex,
    Stat,
    StatLabel,
    useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import Card from "./Card";

const LongParams = ({ title, params }) => {

    const textColor = useColorModeValue("gray.700", "white");

    return (
        <>
            <Card minH='83px'  color={textColor} maxW='800px'>
                <Box display= "flex" width= "100%">
                    <Flex flexDirection='row' align='center' justify='center' w='100%'>
                        <Stat me='auto'>
                            <StatLabel
                                fontSize='sm'
                                fontWeight='bold'
                                pb='.1rem'>
                                {title}
                            </StatLabel>
                        </Stat>
                    </Flex>
                </Box>

                    {params}

            </Card>
        </>
    );
};

export default LongParams;
